import type { IBraintree, IPayPal } from "@/types/PaymentGatewayTypes.ts";
import axios from 'axios'
import { ApiPost } from '@/api/Common.ts'
import type { AxiosError } from 'axios'
import { trackAddPaymentInfo } from '@/analytics/index'
import { HidePayPalButtonPlaceholder } from '@/services/AoeHelpers.ts'

declare const braintree : IBraintree
declare const paypal : IPayPal


class AoeBraintreePaypalCheckout {
  clientToken = ''
  container = ''
  nonce = ''
  paypalScriptUrl = ''
  braintreeScriptUrl = ''
  createPaymentUrl = ''
  cartFunnelType: 'individual' | 'party' | 'recruitment' = 'individual'
  sourceValues = {
    systemKeyword: '',
    aOECartIdToken: '',
  }
  paymentValues = {
    paymentAmount: '',
    currencyCode: '',
  }
  Initialize() {
    console.log('Braintree Paypal Checkout', 'Initialize')
    axios.get(this.paypalScriptUrl).then(() => {
      console.log('Braintree Paypal Checkout', 'paypalScriptUrl done')
      axios.get(this.braintreeScriptUrl).then(() => {
        console.log('Braintree Paypal Checkout', 'braintreeScriptUrl done')
        this.InitializeDocumentReady()
      })
    })
  }
  InitializeDocumentReady() {
    console.log('Braintree Paypal Checkout', 'InitializeDocumentReady')
    // Create a client.
    braintree.client.create(
      {
        authorization: this.clientToken,
      },
      (clientErr, clientInstance) => {
        console.log('braintree.client.create')
        // Stop if there was a problem creating the client.
        // This could happen if there is a network error or if the authorization
        // is invalid.
        if (clientErr) {
          console.error(clientErr)
          return
        }

        // Create a PayPal Checkout component.
        braintree.paypalCheckout.create(
          {
            client: clientInstance,
          },
          (paypalCheckoutErr, paypalCheckoutInstance) => {
            console.log('braintree.paypalCheckout.create this:', this)
            // If an error occurred, log it
            if (paypalCheckoutErr) {
              console.error(paypalCheckoutErr)
              return
            }

            paypalCheckoutInstance.loadPayPalSDK(
              {
                currency: this.paymentValues.currencyCode,
                intent: 'capture',
              },
              () => {
                console.log('paypalCheckoutInstance.loadPayPalSDK this:', this)
                paypal
                  .Buttons({
                    fundingSource: paypal.FUNDING.PAYPAL,

                    createOrder: () => {
                      console.log('createOrder this:', this)
                      return paypalCheckoutInstance.createPayment({
                        flow: 'checkout', // Required
                        amount: this.paymentValues.paymentAmount, // Required
                        currency: this.paymentValues.currencyCode, // Required, must match the currency passed in with loadPayPalSDK
                        intent: 'capture', // Must match the intent passed in with loadPayPalSDK
                        enableShippingAddress: false,
                        shippingAddressEditable: false,
                      })
                    },

                    onApprove:  (data : object) => {
                      console.log('onApprove', data)
                      return paypalCheckoutInstance.tokenizePayment(
                        data,
                        (err, payload) => {
                          console.log('tokenizePayment this:', this)
                          if (err) {
                            console.error(err)
                            return
                          }

                          this.CreatePayment(payload)
                        },
                      )
                    },

                    onCancel: () => {
                      console.log('onCancel')
                    },

                    onError:  (err : object) => {
                      console.error(err)
                    },
                  })
                  .render('#braintreepaypalbutton')
                  .then(() => {
                    // The PayPal button will be rendered in an html element with the ID
                    // `paypal-button`. This function will be called when the PayPal button
                    // is set up and ready to be used
                    HidePayPalButtonPlaceholder()
                  })
              },
            )
          },
        )
      },
    )
  }
  CreatePayment(payload : object) {
    console.debug('SavePayment', payload)
    const jsonDataToSave = {
      systemKeyword: this.sourceValues.systemKeyword,
      aOECartIdToken: this.sourceValues.aOECartIdToken,
      BraintreePayPalTokenizeResponse: {
        ...payload,
        clientToken: this.clientToken,
        flow: 'checkout',
      },
      charge: Number(this.paymentValues.paymentAmount),
    }
    if (this.createPaymentUrl && this.createPaymentUrl.length > 0) {
      ApiPost(this.createPaymentUrl, jsonDataToSave)
      .then((result: object) => {
        console.log('Processing complete', result)
        trackAddPaymentInfo(
          'paypal',
          Number(this.paymentValues.paymentAmount) || 0,
          this.paymentValues.currencyCode || 'EUR',
          this.cartFunnelType || 'individual'
        )
        const successMessage = {
          messageType: 'aoepaymentcreated',
          messageData: result,
        }
        window.postMessage(successMessage)
      })
      .catch((errorResult: object) => {
        console.log('Processing error', errorResult)
        const axiosError = errorResult as AxiosError
        let messageData = null
        if (axiosError) {
          messageData = axiosError.response?.data
        }
        const errorMessage = {
          messageType: 'aoepaymentcreationerror',
          messageData: messageData,
        }
        window.postMessage(errorMessage)
      })
    } else {
      console.error('createPaymentUrl is empty')
    }
  }
}
export const aoeBraintreePaypalCheckout = new AoeBraintreePaypalCheckout()
